export const getElementContentHeight = (elt) => {
  if (!elt) return 0;
  let totalHeight = 0;
  elt.childNodes.forEach((child) => {
    const el = child as HTMLElement;
    totalHeight += el.clientHeight || 0;
    if (child.nodeType === document.ELEMENT_NODE) {
      const style = window.getComputedStyle(el);
      if (style.marginTop) totalHeight += parseInt(style.marginTop, 10);
      if (style.marginBottom) totalHeight += parseInt(style.marginBottom, 10);
    }
  });
  const style = window.getComputedStyle(elt);
  if (style.paddingTop) totalHeight += parseInt(style.paddingTop, 10);
  if (style.paddingBottom) totalHeight += parseInt(style.paddingBottom, 10);
  if (style.borderTopWidth) totalHeight += parseInt(style.borderTopWidth, 10);
  return totalHeight + 1;
}